import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { post } from "../../../../actions/general";

import Modal from "../../../Modal";
import Form, { Title, Submit, InputTextArea, Cancel } from "../../../Form";

import messages from "./messages";
import { IProps } from "./interfaces";

const Report = ({ close, planId }: IProps) => {
    const dispatch = useDispatch();
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const submit = () => {
        dispatch(post("report-plan", { message, planId }, () => {
            setSuccess(true);
        }));
    };

    const changeMessage = (e: React.FormEvent<HTMLTextAreaElement>) => {
        setMessage(e.currentTarget.value)
    }

    return (
        <Modal close={close}>
            <Form>
                <Title>
                    <FormattedMessage {...messages.title} />
                </Title>
                {!success && (
                    <div>
                        <p>
                            <FormattedMessage {...messages.description} />
                        </p>
                        <InputTextArea value={message} onChange={changeMessage} />
                        <Submit onClick={submit}>
                            <FormattedMessage {...messages.submit} />
                        </Submit>
                        <Cancel onClick={() => close()}>
                            <FormattedMessage {...messages.cancel} />
                        </Cancel>
                    </div>
                )}
                {success && (
                    <div>
                        <p>
                            <FormattedMessage {...messages.success} />
                        </p>
                        <Cancel onClick={() => close()}>
                            <FormattedMessage {...messages.close} />
                        </Cancel>
                    </div>
                )}
            </Form>
        </Modal>
    );
}

export default Report;
